// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"b4f5ca95","553":"60acfe5c","703":"3d751ecc","787":"17be3e0c"}[chunkId] + ".chunk.js";
};